<template>
  <div class="row">
    <div class="col-6">
      <textarea maxlength="5000" class="form-control" id="exampleFormControlTextarea1" rows="5"
        placeholder="Informacoes complementares" v-model="form.informacao_complementar.value" />
    </div>
    <br />
    <div class="col-6">
      <textarea maxlength="5000" class="form-control" id="exampleFormControlTextarea2" rows="5"
        placeholder="Informacoes ao fisco" v-model="form.informacao_fisco.value" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {},
    form: {}
  },
  data() {
    return {
      informacao_complementar: {
        value: null
      },

      informacao_fisco: {
        value: null
      }
    };
  }
};
</script>
